export const locationUrl = 'https://api.allorigins.win/raw?url=https://www.metaweather.com';
export const locationSearch = '/api/location/search/?query=';
export const locationData = '/api/location/';
export const userIpUrl = 'https://api.ipify.org?format=json'
//export const geolocationUrl = 'http://api.ipstack.com/'
//export const accessKey = 'fb03393153350bdc9583e7f1736094f0'
export const geolocationUrl = 'https://api.ipgeolocation.io/ipgeo?'
export const accessKey = 'e5ab27db90f447c0bf97e99d3afd143f'

